<template>
  <div style="width: 100%;height: 100%">
    <div class="title"><span>入住人数</span></div>
    <div class="content">
      <div class="content-top">
        <el-row style="height: 100%">
          <el-col :span="16" style="height: 100%">
            <div :style="{width: '100%', height: '100%', zoom: 1 / this.golobleObject.zoom}" id="gauge" ref="gaugeWrap"></div>
          </el-col>
          <el-col :span="8" style="height: 100%;display: flex">
            <div style="width: 110px;height: 140px;margin: auto">
              <div style="width: 100%;height: 35px;line-height: 35px"><span style="color: #bfc7c9;font-size: 14px">床位数：</span><span style="color: #23fffc;font-size: 24px;font-family: letisgoDigital!important;">{{bedCnt}}</span></div>
              <div style="width: 100%;height: 35px;line-height: 35px"><span style="color: #bfc7c9;font-size: 14px">入住数：</span><span style="color: #5470c6;font-size: 24px;font-family: letisgoDigital!important;">{{checkinCnt}}</span></div>
              <div style="width: 100%;height: 35px;line-height: 35px"><span style="color: #bfc7c9;font-size: 14px">请假数：</span><span style="color: #91cc75;font-size: 24px;font-family: letisgoDigital!important;">{{askLeaveCnt}}</span></div>
              <div style="width: 100%;height: 35px;line-height: 35px"><span style="color: #bfc7c9;font-size: 14px">预约数：</span><span style="color: #fac858;font-size: 24px;font-family: letisgoDigital!important;">{{waitCnt}}</span></div>
            </div>
          </el-col>
        </el-row>
<!--        <el-row style="height: 100%">-->
<!--          <el-col :span="12" style="height: 100%">-->
<!--            <div class="content-top-left">-->
<!--              <el-row style="height: 100%">-->
<!--                <el-col :span="12" style="height: 100%">-->
<!--                  <div class="content-top-title">楼栋数</div>-->
<!--                  <div class="content-top-value-left">{{buildCnt}}</div>-->
<!--                </el-col>-->
<!--                <el-col :span="12" style="height: 100%">-->
<!--                  <div class="content-top-title">床位数</div>-->
<!--                  <div class="content-top-value-left">{{bedCnt}}</div>-->
<!--                </el-col>-->
<!--              </el-row>-->
<!--            </div>-->
<!--          </el-col>-->
<!--          <el-col :span="12" style="height: 100%">-->
<!--            <div class="content-top-right">-->
<!--              <el-row style="height: 100%">-->
<!--                <el-col :span="8" style="height: 100%">-->
<!--                  <div class="content-top-title">入住数</div>-->
<!--                  <div class="content-top-value-right">{{checkinCnt}}</div>-->
<!--                </el-col>-->
<!--                <el-col :span="8" style="height: 100%">-->
<!--                  <div class="content-top-title">请假数</div>-->
<!--                  <div class="content-top-value-right">{{askLeaveCnt}}</div>-->
<!--                </el-col>-->
<!--                <el-col :span="8" style="height: 100%">-->
<!--                  <div class="content-top-title">预约数</div>-->
<!--                  <div class="content-top-value-right">{{waitCnt}}</div>-->
<!--                </el-col>-->
<!--              </el-row>-->
<!--            </div>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </div>
      <div class="content-bottom">
        <div :style="{width: '100%', height: '100%', zoom: 1 / this.golobleObject.zoom}" id="bar" ref="wrap"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {queryorgbedcount} from '../../../api/yanglaoyuan/dataScreen'

export default {
  name: 'personStatistic',
  data () {
    return {
      gauge: null,
      personCnt: 0,
      buildCnt: 0,
      bedCnt: 0,
      checkinCnt: 0,
      askLeaveCnt: 0,
      waitCnt: 0,

      chart: null,
      // yData: [],
      // yDataAll: [],
      // seriesArr: []
      yData: [],
      xDataEmpty: [],
      xDataUsed: [],
      xDataTotal: []
    }
  },
  created () {
    this.getChartData()
  },
  mounted () {
    window.addEventListener('resize', this.chartResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.chartResize)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    if (this.gauge) {
      this.gauge.dispose()
      this.gauge = null
    }
  },
  methods: {
    getStartData (obj) {
      this.personCnt = obj.personcount
      this.buildCnt = obj.buildingcount
      this.bedCnt = obj.bedcount
      this.checkinCnt = obj.bindbedcount
      this.askLeaveCnt = obj.leavebedcount
      this.waitCnt = obj.orderbedcount
      this.getGauge()
    },
    getGauge () {
      if (!this.gauge) {
        this.gauge = this.$echarts.init(this.$refs.gaugeWrap)
      }
      const gaugeData = [
        {
          value: (this.checkinCnt / this.bedCnt * 100).toFixed(2),
          name: '入住数：',
          title: {
            offsetCenter: ['150%', '-80%']
          },
          detail: {
            offsetCenter: ['180%', '-78%']
          }
        },
        {
          value: (this.askLeaveCnt / this.bedCnt * 100).toFixed(2),
          name: '请假数：',
          title: {
            offsetCenter: ['150%', '-40%']
          },
          detail: {
            offsetCenter: ['180%', '-38%']
          }
        },
        {
          value: (this.waitCnt / this.bedCnt * 100).toFixed(2),
          name: '预约：',
          title: {
            offsetCenter: ['150%', '-5%']
          },
          detail: {
            offsetCenter: ['180%', '-3%']
          }
        }
      ]
      let option = {
        tooltip: {
          trigger: 'item', // 触发类型, axis: 坐标轴触发
          formatter: '{b0}{c0}%'
        },
        series: [
          {
            type: 'gauge',
            min: 0,
            max: 100,
            radius: '150%',
            center: ['50%', '80%'],
            startAngle: 190,
            endAngle: -10,
            splitNumber: 5,
            anchor: {
              show: true,
              showAbove: true,
              size: 10,
              itemStyle: {
                color: '#FAC858'
              }
            },
            pointer: {
              icon: 'path://M2.9,0.7L2.9,0.7c1.4,0,2.6,1.2,2.6,2.6v115c0,1.4-1.2,2.6-2.6,2.6l0,0c-1.4,0-2.6-1.2-2.6-2.6V3.3C0.3,1.9,1.4,0.7,2.9,0.7z',
              width: 6,
              length: '80%',
              offsetCenter: [0, '0%']
            },
            progress: {
              show: true,
              overlap: true,
              roundCap: true
            },
            axisLine: {
              roundCap: true
            },
            axisTick: {
              color: '#fff'
            },
            axisLabel: {
              color: '#bfc7c9',
              formatter: function (value) {
                return value + '%'
              }
            },
            data: gaugeData,
            title: {
              show: false,
              fontSize: 14,
              color: '#bfc7c9'
            },
            detail: {
              show: false,
              width: 40,
              height: 14,
              fontSize: 14,
              color: 'auto',
              backgroundColor: 'transparent',
              borderRadius: 3,
              formatter: '{value}'
            }
          }
        ]
      }
      this.gauge.setOption(option)
    },
    getChart () {
      if (!this.chart) {
        this.chart = this.$echarts.init(this.$refs.wrap)
      }
      let option = {
        tooltip: {
          trigger: 'item', // 触发类型, axis: 坐标轴触发
          axisPointer: {
            // 指示器类型  'line' 直线指示器 'shadow' 阴影指示器 'none' 无指示器 'cross' 十字准星指示器。
            // 其实是种简写，表示启用两个正交的轴的 axisPointer。
            type: 'none'
          }
        },
        legend: {
          show: true,
          textStyle: {
            color: '#fff',
            fontSize: 10
          }
        },
        // tooltip: {
        //   trigger: 'item',
        //   axisPointer: {type: 'cross', label: {backgroundColor: '#283b56'}}
        // },
        yAxis: {
          type: 'category',
          axisLine: { show: false, lineStyle: { color: '#7fd4ff', width: 1 } },
          axisPointer: { type: 'cross' },
          axisTick: { show: false },
          // offset: 10,
          axisLabel: {
            interval: 0,
            margin: 5,
            formatter: '{value}  {a|}',
            rich: {
              a: {
                backgroundColor: {
                  image: 'static/dataRank.png'
                },
                height: 40,
                width: 11
              }
            },
            textStyle: {
              color: '#bfc7c9',
              fontWeight: 'bold',
              fontSize: 12
            }
          },
          // max: function (value) {
          //   if (value.max < 5) {
          //     value.max = 5
          //   }
          //   return value.max
          // },
          data: this.yData
        },
        xAxis: {
          show: false,
          name: '',
          type: 'value',
          axisLine: { lineStyle: { color: '#7fd4ff', width: 1 } },
          axisLabel: { formatter: '{value}' },
          splitLine: { show: true, lineStyle: { color: '#182f4d', width: 1 } }
        },
        grid: {top: '3%', left: '3%', right: '10%', bottom: '0%', containLabel: true},
        series: [
          {
            name: '床位数',
            type: 'bar',
            valueAnimation: true,
            barMaxWidth: 20,
            // Y轴数字显示部分
            label: {
              normal: {
                show: true,
                position: 'right',
                valueAnimation: true,
                offset: [5, 0],
                formatter: '{c}',
                textStyle: {
                  color: '#fff',
                  fontSize: 10
                }
              }
            },
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 1,
                y2: 1,
                colorStops: [{ offset: 0, color: '#0167e8' }, { offset: 1, color: '#13ace8' }],
                global: false
              }
            },
            data: this.xDataTotal
          },
          {
            name: '入住数',
            type: 'bar',
            valueAnimation: true,
            barMaxWidth: 20,
            // Y轴数字显示部分
            label: {
              normal: {
                show: true,
                position: 'right',
                valueAnimation: true,
                offset: [5, 0],
                formatter: '{c}',
                textStyle: {
                  color: '#fff',
                  fontSize: 10
                }
              }
            },
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 1,
                y2: 1,
                colorStops: [{ offset: 0, color: '#8f071e' }, { offset: 1, color: '#f85163' }],
                global: false
              }
            },
            data: this.xDataUsed
          }
        ]
      }
      this.chart.setOption(option)
    },
    // getChart () {
    //   if (!this.chart) {
    //     this.chart = this.$echarts.init(this.$refs.wrap)
    //   }
    //   let series = []
    //   // let arr = [
    //   //   {name: '一层', data: [60, 30, 20, 10, 15]},
    //   //   {name: '二层', data: [20, 10, 30, 40, 5]},
    //   //   {name: '三层', data: [35, 20, 15]},
    //   //   {name: '四层', data: [15, 0, 5]}
    //   // ]
    //   this.seriesArr.forEach(item => {
    //     let obj = {
    //       type: 'bar', // 系列类型
    //       name: item.name, // 系列名称, 用于tooltip的显示, legend 的图例筛选
    //       // 数据堆叠，同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
    //       stack: '总量',
    //       barMaxWidth: 20, // 柱条的最大宽度，不设时自适应
    //       // 图形上的文本标签
    //       label: {
    //         show: true,
    //         // 标签的位置 left right bottom top inside，绝对的像素值 position: [10, 10]，相对的百分比 position: ['50%', '50%']
    //         position: 'inside',
    //         color: '#fff'
    //       },
    //       itemStyle: {
    //         color: 'rgba(61, 252, 205, 0.15)',
    //         // color: '#3dfccd',
    //         // shadowBlur: 200,
    //         // shadowColor: 'rgba(0, 0, 0, 0.5)',
    //         borderColor: '#37d6af',
    //         borderWidth: 1
    //       },
    //       data: item.data // 系列中的数据内容数组
    //     }
    //     series.push(obj)
    //   })
    //   let option = {
    //     // color: ['#3dfccd', '#34d6af', '#37d6af'],
    //     // 设置图表的位置
    //     grid: {
    //       top: '5%',
    //       left: '3%',
    //       right: '4%',
    //       bottom: '3%',
    //       containLabel: true
    //     },
    //     // 提示框组件
    //     tooltip: {
    //       trigger: 'item', // 触发类型, axis: 坐标轴触发
    //       axisPointer: {
    //         // 指示器类型  'line' 直线指示器 'shadow' 阴影指示器 'none' 无指示器 'cross' 十字准星指示器。
    //         // 其实是种简写，表示启用两个正交的轴的 axisPointer。
    //         type: 'none'
    //       },
    //       textStyle: {
    //         color: '#000' // 文字颜色
    //       },
    //       // 提示框浮层内容格式器，支持字符串模板和回调函数两种形式
    //       // 折线（区域）图、柱状（条形）图、K线图 : {a}（系列名称），{b}（类目值），{c}（数值）, {d}（无）
    //       // formatter: '{b}<br />{a0}: {c}人',
    //       formatter: function (params, ticket, callback) {
    //         return params.name + '</br>' + params.seriesName + ': ' + params.data[0] + '人'
    //       }
    //     },
    //     // X轴
    //     xAxis: {
    //       type: 'value', // 坐标轴类型,   'value' 数值轴，适用于连续数据
    //       // 坐标轴刻度
    //       axisTick: {
    //         show: false // 是否显示坐标轴刻度 默认显示
    //       },
    //       // 坐标轴轴线
    //       axisLine: { // 是否显示坐标轴轴线 默认显示
    //         show: false // 是否显示坐标轴轴线 默认显示
    //       },
    //       // 坐标轴在图表区域中的分隔线
    //       splitLine: {
    //         show: false // 是否显示分隔线。默认数值轴显示
    //       },
    //       // 坐标轴刻度标签
    //       axisLabel: {
    //         show: false // 是否显示刻度标签 默认显示
    //       }
    //     },
    //     yAxis: [
    //       // 左侧Y轴
    //       {
    //         type: 'category', // 坐标轴类型,  'category' 类目轴，适用于离散的类目数据，为该类型时必须通过 data 设置类目数据
    //         // 坐标轴刻度
    //         axisTick: {
    //           show: false // 是否显示坐标轴刻度 默认显示
    //         },
    //         // 坐标轴轴线
    //         axisLine: { // 是否显示坐标轴轴线 默认显示
    //           show: false, // 是否显示坐标轴轴线 默认显示
    //           lineStyle: { // 坐标轴线线的颜色
    //             color: '#cdd3ee'
    //           }
    //         },
    //         // 坐标轴在图表区域中的分隔线
    //         splitLine: {
    //           show: false // 是否显示分隔线。默认数值轴显示
    //         },
    //         // 坐标轴刻度标签
    //         axisLabel: {
    //           show: true, // 是否显示刻度标签 默认显示
    //           fontSize: 16, // 文字的字体大小
    //           color: '#bfc7c9', // 刻度标签文字的颜色
    //           // 使用字符串模板，模板变量为刻度默认标签 {value}
    //           formatter: '{value}'
    //         },
    //         data: this.yData // 类目数据，在类目轴（type: 'category'）中有效
    //       },
    //       // 右侧Y轴
    //       {
    //         type: 'category', // 坐标轴类型
    //         // 坐标轴轴线
    //         axisLine: {
    //           show: false
    //         },
    //         // 坐标轴刻度
    //         axisTick: {
    //           show: false
    //         },
    //         // 坐标轴刻度标签
    //         axisLabel: {
    //           show: true, // 是否显示刻度标签 默认显示
    //           fontSize: 16, // 文字的字体大小
    //           color: '#39ffd1', // 刻度标签文字的颜色
    //           // 使用字符串模板，模板变量为刻度默认标签 {value}
    //           formatter: '{value}人'
    //         },
    //         data: this.yDataAll
    //       }
    //     ],
    //     // 系列列表
    //     series: series
    //   }
    //   this.chart.setOption(option)
    // },
    chartResize () {
      this.chart.resize()
      this.gauge.resize()
    },

    getChartData () {
      let that = this
      this.yData = []
      this.xDataEmpty = []
      this.xDataUsed = []
      this.xDataTotal = []
      queryorgbedcount().then(res => {
        let arr = res.data.orgbedcount
        arr.forEach(item => {
          that.yData.unshift(item.build_name)
          that.xDataEmpty.unshift([item.build_name, item.emptybedcount])
          that.xDataUsed.unshift(item.bindbedcount)
          that.xDataTotal.unshift(item.bindbedcount + item.emptybedcount)
        })
        // console.log(that.yData, that.xDataUsed, that.xDataTotal)
        this.getChart()
      })
    }
  }
}
</script>

<style scoped>
.title {
  padding-left: 45px;
  height: 32px;
  width: calc(100% - 45px);
  background: url("../../../assets/dataScreen/title1.png") no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
  font-size: 15px;
  line-height: 32px;
}
.content {
  height: calc(100% - 52px);
  width: calc(100% - 20px);
  padding: 10px;
  background-image: linear-gradient(
    #0b182c,
    #0b182c),
  linear-gradient(
    #03171f,
    #03171f);
}
.content-top {
  width: 100%;
  height: 180px;
}
.content-bottom {
  width: 100%;
  height: calc(100% - 190px);
  padding-top: 10px;
}
.content-top-left {
  margin: 10px;
  padding: 25px 10px 0 10px;
  width: calc(100% - 40px);
  height: 75px;
  background: url("../../../assets/dataScreen/card1.png") no-repeat;
  background-size: 100% 100%;
}
.content-top-right {
  margin: 10px;
  padding: 25px 10px 0 10px;
  width: calc(100% - 40px);
  height: 75px;
  background: url("../../../assets/dataScreen/card2.png") no-repeat;
  background-size: 100% 100%;
}
.content-top-title {
  height: 25px;
  width: 100%;
  color: #ffffff;
  font-size: 15px;
  line-height: 25px;
  text-align: center
}
.content-top-value-left {
  height: 50px;
  width: 100%;
  color: #23fffc;
  font-size: 22px;
  line-height: 50px;
  text-align: center
}
.content-top-value-right {
  height: 50px;
  width: 100%;
  color: #23b9ff;
  font-size: 22px;
  line-height: 50px;
  text-align: center
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/dataScreenComponents/personStatistic.vue